// extracted by mini-css-extract-plugin
module.exports = {"landingView":"LandingView_landingView__3Cyy_","scrollable":"LandingView_scrollable__cYaVA","scrollableContent":"LandingView_scrollableContent__3ZL5P"};